import * as R from 'ramda'
import {
  RoomListSearchData,
  roomListSearchStorage,
} from './room-list-search.storage'
import { getPv } from '$logic/pv'
import { getRooms } from '$logic/room'

const RECENT_USER_COUNT = 10

export function getRoomListSearchData() {
  return roomListSearchStorage.get() || { recentUsers: [], recentSearch: [] }
}

export async function addToRecentSearch(item: {
  id: string
  type: 'USER' | 'ROOM'
}) {
  const { recentUsers, recentSearch: oldSearch } = getRoomListSearchData()
  const recentSearch = [
    item,
    ...R.reject(({ id }) => id === item.id, oldSearch),
  ]

  await roomListSearchStorage.set({ recentUsers, recentSearch })
}

export async function calculateRecentUsers() {
  const rooms = getRooms()
  const pvRooms = rooms.filter(R.propEq('type', 'PV'))

  const recentUsers = (await Promise.all(
    R.sort(R.descend(R.prop('updatedAt')), pvRooms)
      .slice(0, RECENT_USER_COUNT)
      .map(room =>
        getPv(room.id).then(pv => ({
          userId: pv.to,
          roomId: pv.roomId,
        })),
      ),
  )) as RoomListSearchData['recentUsers']

  const { recentSearch } = getRoomListSearchData()
  await roomListSearchStorage.set({ recentUsers, recentSearch })
}

export async function deleteAllRecentSearch() {
  const { recentUsers } = getRoomListSearchData()
  await roomListSearchStorage.set({ recentUsers, recentSearch: [] })
}

export async function deleteFromRecentSearch(item: {
  id: string
  type: 'USER' | 'ROOM'
}) {
  const { recentUsers, recentSearch: oldSearch } = getRoomListSearchData()
  const recentSearch = R.reject(({ id }) => id === item.id, oldSearch)

  await roomListSearchStorage.set({ recentUsers, recentSearch })
}
